import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, Header } from 'components';
import {
	Card,
	CardContent,
	TextField,
	Grid,
	Button,
	colors
} from '@mui/material';

import { GetIpInefficientUse } from '../../actions/IpAuditsActions.js';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

const ServiceIpAssignment = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const user = useSelector(state => state.session.user);

	const _getIpInefficientUse = () => {
		dispatch(GetIpInefficientUse(user.id));
	};

	return (
		<Page className={classes.root} title="IP Audits">
			<Header module="IpAudits" view="IP Inefficient Use" />
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardContent>
						<Grid container spacing={2}>
							<Grid item md={4} xs={4}>
								<Button
									color="primary"
									variant="contained"
									size="large"
									onClick={_getIpInefficientUse}
								>
									Get Report
								</Button>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default ServiceIpAssignment;
